import { apiCall } from './api';
import { cleanJSON } from './utils';

( function ArchiveLoading() {

  // Get out of here if not on the right page.
  if(
    ! $WP_Body.hasClass( 'blog' ) &&
    ! $WP_Body.hasClass( 'archive' )
  ) {
    return;
  }

  /* ------ = Constants = --------------------------------------------------------------------- */
  const filter_selector = '[data-archive-filter]';
  const filter_choice_selector = '[data-archive-filter-choice]';
  const $filter_choices = $( document.querySelectorAll( filter_choice_selector ) );
  const listing_container_selector = '[data-archive-listings]';
  const $listings_container = $( document.querySelectorAll( listing_container_selector ) );
  const listing_selector = '[data-archive-snippet]';
  const $clear_filter = $( document.querySelectorAll( '[data-clear-filter]' ) );
  const $loadmore = $( document.querySelectorAll( '[data-loadmore]' ) );
  const filter_types = [];
  $filter_choices.map( ( index, choice ) => {

    filter_types.push( choice.dataset.archiveFilterType );

  } );


  setupFilter();
  setupInfiniteLoading();

  /**
  * Set up the filter to filter posts by topic.
  */
  function setupFilter() {

    // User clicks to clear filter
    $clear_filter.on( 'click', function() {

      const $filter = $( this.closest( filter_selector ) );

      clearFilter( $filter );


    } );


    // User clicks on a filter choice.
    $filter_choices.on( 'click', function() {

      const $choice = $(this);
      const is_checked = $choice[0].checked;
      const choice_id = $choice.data( 'archive-filter-choice' );
      const choice_type = $choice.data( 'archive-filter-type' );
      let listings_active_choices = $listings_container.attr( 'data-' + choice_type );

      // Choice is being selected.
      if( is_checked ) {

        // If listing container doesn't have this choice filtered, add it.
        if( ! listings_active_choices.includes( choice_id ) ) {

          listings_active_choices += choice_id + ',';

        }
      }
      // Choice is being deselected and we have some choices to remove.
      else if( listings_active_choices ) {

        listings_active_choices = listings_active_choices.replace( choice_id + ',', '' );

      }

      // Set the new topic within listing params.
      $listings_container.attr( 'data-' + choice_type, listings_active_choices );

      // Run the filter.
      runFilter();

    } );

    /**
     * Clear the filter.
     *
     * @param jQuery_Object {$filter}
     */
    function clearFilter( $filter ) {

      const $choices = $filter.find( filter_choice_selector );
      const filter_type = $filter.data( 'archive-filter' );

      // Remove checks from all choices.
      $choices.removeAttr( 'checked' );

      // Clear the data in listings container.
      $listings_container.attr( 'data-' + filter_type, '' );
      $listings_container.attr( 'data-count', '' );

      runFilter();

    }

    /**
    * Run the filter.
    */
    function runFilter() {

      const params = {}
      filter_types.map( ( type ) => {

        params[type + '_ids'] = $listings_container.attr( 'data-' + type ).toString();

      } );
      params.count = $listings_container.attr( 'data-count' );

      const filter_args = {
        method: 'get',
        route: $listings_container.data( 'archive-listings' ),
        params: params,
        success: ( results ) => {

          $listings_container.find( listing_selector ).remove();
          $listings_container.prepend( results.html );

        }
      }

      $WP_Body.addClass( 'is-running-blog-filter' );

      apiCall( filter_args );

    }

  }


  /**
  * Setup infinite loading.
  */
  function setupInfiniteLoading() {

    // Get the posts when user clicks loadmore.
    $loadmore.on( 'click', getPosts );


    /**
    * Get the posts.
    */
    function getPosts() {

      const $listings = $( document.querySelectorAll( listing_selector ) );
      const posts_loaded = $( document.querySelectorAll( listing_selector ) ).length;
      const params = {}
      filter_types.map( ( type ) => {

        params[type + '_ids'] = $listings_container.attr( 'data-' + type );

      } );
      params.count = $listings_container.attr( 'data-count' );
      params.offset = posts_loaded;

      const filter_args = {
        method: 'get',
        route: $listings_container.data( 'archive-listings' ),
        params: params,
        success: ( results ) => {

          $( $listings.last() ).after( results.html );

        }
      }

      $WP_Body.addClass( 'is-loading-more-posts' );

      apiCall( filter_args );

    }


  }



} )( jQuery );



// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/archive-loading.js